export default async ({ app, $axios, $config }) => {
    try {
        await $axios
            .get('/settings/global_site_settings', {
                headers: {
                    token: $config.TOKEN
                }
            })
            .then(e => {
                const langs = e?.data?.langs;
                const mainLang = e?.data?.mainUiInterface?.mainLang;

                const locales = [
                    { code: 'ro', iso: 'ro-RO', file: 'ro.js', dir: 'ltr', name: 'Romana' },
                    { code: 'ru', iso: 'ru-RU', file: 'ru.js', dir: 'ltr', name: 'Русский' },
                    { code: 'uk', iso: 'uk', file: 'ua.js', dir: 'ltr', name: 'Український' },
                    { code: 'en', iso: 'en-EN', file: 'en.js', dir: 'ltr', name: 'English' }
                ];

                app.i18n.defaultLocale = mainLang;
                app.i18n.fallbackLocale = mainLang;
                app.i18n.locales = locales.filter(locale => langs.some(serverLocale => serverLocale.code === locale.code));
            });
    } catch (error) {
        console.error('wrong locale:', error);
    }
};
